export default "__VITE_ASSET__daa71cdc__"